import { render, staticRenderFns } from "./otherPay.vue?vue&type=template&id=3acf5994&"
import script from "./otherPay.vue?vue&type=script&lang=js&"
export * from "./otherPay.vue?vue&type=script&lang=js&"
import style0 from "./otherPay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports